<div *ngIf="privilegesView==='AccessDenied'" class=" outside-container  mt-4" >
    <div class="box-container">
      <div class="container">
        <div *ngIf="privilegesView==='AccessDenied'" class="  d-flex justify-content-center" >
  
    <img src="../../../assets/images/AccessDeniedError.png" alt="">
  </div>
  
   </div>
  </div>
  </div>
  
  <div *ngIf="privilegesView==='VAMD'" class="outside-container mt-4">
      <div class="box-container ">
          <div class="container">
              <div class="title ">
  
                <div class="row">
                  <div class=" col-md-2  " ><div class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;">⬅️</div></div>  
                 <div class="col-md-7 d-flex justify-content-center">Hotel Management</div>
                 <div class=" col-md-3 row ">
                   <div class="d-flex justify-content-end">
                    <button *ngIf="showSupplier" class="btn btn-outline-primary btn-sm " (click)="onAddSupplier()"><img src="assets/images/Add_24.png"></button>
                    <button  *ngIf="showSource" class="btn btn-outline-primary btn-sm " (click)="onAddSource()"><img src="assets/images/Add_24.png"></button>
  
                 </div>
                  </div>
                </div>
              
              </div> 
              </div>
              </div>
            </div>
            <div *ngIf="privilegesView==='VAMD'" class="outside-container ">
              <div class="box-container ">
                  <div class="container ">
                    <div class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
                   
                   
                      <div class="col-md-2  " [ngStyle]="{'background-color':color?.sideBarColor}"  style="border-radius: 4px; content: right; padding-top: 10px; height:70vh;overflow-y: auto; ">
                        <div class="col-md-12 ">
                        <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickSource()"     [ngClass]="{'activity' :showSource}">Sources</span></span> 
                        <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickSupplier()"  [ngClass]="{'activity' :showSupplier}">Supplier</span></span>

                      </div>
                        
                      </div>
  
                     <div class="col-md-10" style="height:70vh; overflow-y: auto;">
                      
                        <div *ngIf="showSupplier" class="col-md-12 card" style="min-height: 100%;" >
                        
                          <div class=" row mt-3 " style="padding: 10px;">
                         
                          
                            <div class="col-md-12 " >
                              <div class="row">
                              <!-- <mat-form-field class=" col-md-3 mt-1 form-group " >
                                <input matInput type="text"  [(ngModel)]="supplierSearch.searchText"  placeholder="Search..." autocomplete="off" (input)="searchSupplier()"  >
                              
                              </mat-form-field>
                              <mat-paginator  class="col-md-9 mt-2 " style="background-color: transparent;" color="primary"
                              [pageSize]="10"
                              [pageSizeOptions]="[5, 10, 25, 100]"
                              [length]="totalElements"
                              (page)="nextSupplierPage($event)"
                              aria-label="Select page">
                              </mat-paginator> -->
                              
                              </div>
                              
                              <table mat-table
                              [dataSource]="supplierData" multiTemplateDataRows style="background-color: transparent;">
                             
                              <ng-container matColumnDef="code">
                               <th mat-header-cell *matHeaderCellDef> Code </th>
                               <td mat-cell *matCellDef="let element;" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" (click)="rowSupplierClick(element)"> {{ element?.code}} </td>
                              </ng-container>
                               <ng-container matColumnDef="name">
                                 <th mat-header-cell *matHeaderCellDef>Name</th>
                                 <td mat-cell *matCellDef="let element" > {{element?.name}} </td>
                               </ng-container>
                               <ng-container matColumnDef="accountCode">
                                <th mat-header-cell *matHeaderCellDef>Account Code</th>
                                <td mat-cell *matCellDef="let element"> {{element?.accountCode}} </td>
                              </ng-container>   
                              <ng-container matColumnDef="source">
                                <th mat-header-cell *matHeaderCellDef>Source</th>
                                <td mat-cell *matCellDef="let element"> {{element?.source}} </td>
                              </ng-container>            
                                                 <ng-container matColumnDef="status">
                               <th mat-header-cell *matHeaderCellDef> Status </th>
                               <td mat-cell *matCellDef="let element"> 
                                <span *ngIf="element.status==='A'">Active</span>
                                <span *ngIf="element.status==='I'">Inactive</span> </td>
                              </ng-container>
                              
                              <!-- email Column -->
                             
                             
                             
                              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                              <ng-container matColumnDef="expandedDetail">
                              <td mat-cell *matCellDef="let element" [attr.colspan]="columnsSupplierDisplay.length">
                              <div class="example-element-detail row"
                               [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                              
                              </div>
                              </td>
                              </ng-container>
                             
                              
                              <tr mat-header-row *matHeaderRowDef="columnsSupplierDisplay"></tr>
                              <tr mat-row *matRowDef="let element; columns: columnsSupplierDisplay;"
                              class="example-element-row">
                              </tr>
                              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                              <tr class="mat-row" *matNoDataRow>
                              <td  class="mat-cell" colspan="4">There is no data in this table</td>
                              </tr>
                              </table>
                              
                              
                              </div>
                              
                          
                        
                        </div> 
                        </div>
                        <div *ngIf="showSource" class="col-md-12 card" style="min-height: 100%;" >
                        
                          <div class=" row mt-3 " style="padding: 10px;">
                         
                          
                            <div class="col-md-12 " >
                              <div class="row">
                              <!-- <mat-form-field class=" col-md-3 mt-1 form-group " >
                                <input matInput type="text"  [(ngModel)]="sourceSearch.searchText"    placeholder="Search..." autocomplete="off" (input)="searchSource()"  >
                              
                              </mat-form-field> -->
                              <!-- <mat-paginator  class="col-md-9 mt-2 " style="background-color: transparent;" color="primary"
                              [pageSize]="10"
                              [pageSizeOptions]="[5, 10, 25, 100]"
                              [length]="totalElements"
                              (page)="nextSourcePage($event)"
                              aria-label="Select page">
                              </mat-paginator> -->
                              
                              </div>
                              
                              <table mat-table
                              [dataSource]="sourceData" multiTemplateDataRows style="background-color: transparent;">
                             
                              <!-- <ng-container matColumnDef="code">
                               <th mat-header-cell *matHeaderCellDef> Code </th>
                               <td mat-cell *matCellDef="let element;"> {{element.code}} </td>
                              </ng-container> -->
                              <ng-container matColumnDef="code">
                                <th mat-header-cell *matHeaderCellDef>Code</th>
                                <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" (click)="rowSourceClick(element)"> {{element.code}} </td>
                              </ng-container>
                               <ng-container matColumnDef="name">
                                 <th mat-header-cell *matHeaderCellDef>Name</th>
                                 <td mat-cell *matCellDef="let element" > {{element.name}} </td>
                               </ng-container>
                               <ng-container matColumnDef="accountCode">
                                <th mat-header-cell *matHeaderCellDef>Account Code</th>
                                <td mat-cell *matCellDef="let element"> {{element?.accountCode}} </td>
                              </ng-container>  
                            
                              <ng-container matColumnDef="status">
                               <th mat-header-cell *matHeaderCellDef> Status </th>
                               <td mat-cell *matCellDef="let element" > 
                                <span *ngIf="element.status==='A'">Active</span>
                                <span *ngIf="element.status==='I'">Inactive</span>
                              </td>
                              </ng-container>
                              
                              <!-- <ng-container matColumnDef="groupCode">
                                <th mat-header-cell *matHeaderCellDef> Group Code </th>
                                <td mat-cell *matCellDef="let element;"> {{ element.groupCode}} </td>
                               </ng-container>
                               <ng-container matColumnDef="supplierCode">
                                <th mat-header-cell *matHeaderCellDef> Supplier Code </th>
                                <td mat-cell *matCellDef="let element;"> {{element.supplierCode}} </td>
                               </ng-container> -->
                             
                              <ng-container matColumnDef="creationDate">
                                <th mat-header-cell *matHeaderCellDef>Creation Date </th>
                                <td mat-cell *matCellDef="let element"> {{formatDate(element.genTs)}} </td>
                               </ng-container>
                             
                              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                              <ng-container matColumnDef="expandedDetail">
                              <td mat-cell *matCellDef="let element" [attr.colspan]="columnsSourceDisplay.length">
                              <div class="example-element-detail row"
                               [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                              
                              </div>
                              </td>
                              </ng-container>
                              
                              <tr mat-header-row *matHeaderRowDef="columnsSourceDisplay"></tr>
                              <tr mat-row *matRowDef="let element; columns: columnsSourceDisplay;"
                              class="example-element-row">
                              </tr>
                              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                              <tr class="mat-row" *matNoDataRow>
                              <td  class="mat-cell" colspan="4">There is no data in this table</td>
                              </tr>
                              </table>
                              
                              
                              </div>
                              
                          
                        
                        </div> 
                        </div>
  
                      
  
                         
                      </div>
                      </div>
                  </div>
  
                  <div class="modal" id="myMod" [style.display]="showSupplierPopup ? 'block' : 'none'" >
                    <div class="modal-dialog" >
                        <div class="modal-content " >
                            <div class="modal-header title">
                              <h4 class="modal-title">Add Supplier</h4>
                              <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                              </div>
                              <div class="modal-body">
                              <div class="col-md-12 mt-3 " *ngIf="showSupplierPopup">
                                <div class="col-md-12 d-flex justify-content-center" >
                                <div class="col-md-12 row " >
                                    <div class=" col-md-12 ">
                                        <form  [formGroup]="SupplierRegFg" (ngSubmit)="AddSupplier()" autocomplete="off"  class=" row" >
                                         
                                           <mat-form-field class="col-md-12" appearance="outline">
                                            <mat-label>Supplier Code</mat-label>
                                            
                                            <input matInput type="text" maxlength="30" name="supplierCode" [readonly]="action!='newSupplier'" formControlName="code" autocomplete="off">
                                            <small *ngIf="SupplierRegFg.controls['code'].dirty && SupplierRegFg.controls['code'].invalid" class="warn">Please Enter Supplier Code!</small>
  
                                          </mat-form-field>
                                          <mat-form-field class="col-md-12" appearance="outline">
                                            <mat-label>Supplier Name</mat-label>
                                            <input matInput type="text" maxlength="30" name="supplierName" formControlName="name" autocomplete="off">
                                            <small *ngIf="SupplierRegFg.controls['name'].dirty && SupplierRegFg.controls['name'].invalid" class="warn">Please Enter Supplier Name!</small>
  
                                          </mat-form-field>
                                          <mat-form-field  class="col-md-12"  appearance="outline">
                                            <mat-label>Source</mat-label>
                                           
                                            <mat-select matNativeControl   formControlName="source"   name="source"  >
                                              <mat-option   class="mat-primary" *ngFor="let list of  sourceData"  [value]="list.code" >{{list?.name}} </mat-option>
                                            </mat-select>
                                    
                                          </mat-form-field> 
                                          <mat-form-field class="col-md-12" appearance="outline">
                                            <mat-label>Account Code</mat-label>
                                            <input matInput type="text" maxlength="30" name="accountSCode" formControlName="accountCode" autocomplete="off">
                                            <small *ngIf="SupplierRegFg.controls['name'].dirty && SupplierRegFg.controls['name'].invalid" class="warn">Please Enter Account Code!</small>
  
                                          </mat-form-field>
                                         
                                          
                                        
                                                                               
                                          </form>                               
                                    </div>
                                    </div>
                                    </div>                                      
                              </div>
                                <div class="modal-footer">
                                  <div class="form-group form-inline ">
                                    <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                                  </div>   
                                  <button *ngIf="action==='newSupplier'" class="btn btn-outline-success c-width-100px shadow " (click)="AddSupplier()" [disabled]="SupplierRegFg.invalid" >Save</button>
                                  <button *ngIf="action!='newSupplier'" class="btn btn-outline-success c-width-100px shadow " (click)="updateSupplier()" [disabled]="SupplierRegFg.invalid" >Update</button>

                                  <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                                </div>
                              </div>
                              </div>
                      </div>
                  </div>
                  <div class="modal" id="myMod" [style.display]="showSourcePopup ? 'block' : 'none'" >
                    <div class="modal-dialog" >
                        <div class="modal-content " >
                            <div class="modal-header title">
                              <h4 *ngIf="action==='newSource'" class="modal-title">Add Source </h4>
                              <h4 *ngIf="action!='newSource'" class="modal-title">Edit Source </h4>
  
                              <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                              </div>
                              <div class="modal-body">
                              <div class="col-md-12 mt-3 " *ngIf="showSourcePopup">
                                <div class="col-md-12 d-flex justify-content-center" >
                                <div class="col-md-12 row " >
                                    <div class=" col-md-12 ">
                                        <form  [formGroup]="SourceRegFg" (ngSubmit)="AddSource()" autocomplete="off"  class=" row" >
                                          
                                           <mat-form-field class="col-md-12" appearance="outline">
                                            <mat-label>  Source Code </mat-label>
                                            <input matInput type="text" name="sourcecode" [readonly]="action!='newSource'" maxlength="30" formControlName="code" autocomplete="off">

                                            <!-- <mat-select matNativeControl name="sourceCode" formControlName="code" (selectionChange)="onSourceSelect($event)">
                                              <mat-option *ngFor="let item of sourceCodeList" [value]='item.code'>{{item.title}}</mat-option>
                                              
                                            </mat-select>    -->
                                            <small *ngIf="SourceRegFg.controls['code'].dirty && SourceRegFg.controls['code'].invalid" class="warn">Please Enter Source Code!</small>
  
                                          </mat-form-field>
                                         
                                           
                                           <mat-form-field class="col-md-12" appearance="outline">
                                            <mat-label>Source Name</mat-label>
                                            <input matInput maxlength="30" type="text" name="SourceName" formControlName="name" autocomplete="off">
                                            <small *ngIf="SourceRegFg.controls['name'].dirty && SourceRegFg.controls['name'].invalid" class="warn">Please Enter Source Name!</small>
  
                                          </mat-form-field>
                                          <mat-form-field class="col-md-12" appearance="outline">
                                            <mat-label>Account Code</mat-label>
                                            <input matInput type="text" maxlength="30" name="accountCode" formControlName="accountCode" autocomplete="off">
                                            <small *ngIf="SupplierRegFg.controls['name'].dirty && SupplierRegFg.controls['name'].invalid" class="warn">Please Enter Account Code!</small>
  
                                          </mat-form-field>
                                                                                                                
                                          </form>
                                    </div>
                                    </div>
                                    </div>                                      
                              </div>
                                <div class="modal-footer">
                                  <div class="form-group form-inline ">
                                    <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                                  </div>   
                                  <button *ngIf="action==='newSource'" class="btn btn-outline-success c-width-100px shadow " (click)="AddSource()" [disabled]="SourceRegFg.invalid" >Save</button>
                                  <button *ngIf="action!='newSource'" class="btn btn-outline-success c-width-100px shadow " (click)="updateSource()" [disabled]="SourceRegFg.invalid" >Update</button>

                                  <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                                </div>
                              </div>
                              </div>
                      </div>
                  </div>
  
                
                      </div>
                  </div>
                  